/** A dashboard row's review comments in flight, linking to the conversation that holds
 * them. */
import { Link } from "react-router-dom";

import type { ApplyingReview } from "../api/hooks/useDashboard";
import { conversationHref } from "../utils/reviewRunHref";
import { Spinner } from "./Spinner";
import styles from "./Review.module.css";

export const ApplyingReviewNotice = ({
  applying,
  projectId,
}: {
  applying: ApplyingReview;
  projectId: string;
}) => {
  const count = applying.comment_ids.length;
  const what = `${count} review comment${count === 1 ? "" : "s"} being applied`;
  const conversation = conversationHref(applying.conversation_id, projectId);
  const body = (
    <>
      <Spinner label={what} /> {what}
    </>
  );
  return conversation ? (
    <Link
      className={styles.applyingCompact}
      to={conversation}
      data-review-chrome
    >
      {body}
    </Link>
  ) : (
    <span className={styles.applyingCompact} data-review-chrome>
      {body}
    </span>
  );
};
